var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input shipperReview", attrs: { type: "table" } },
    [
      _c("div", { staticClass: "input search" }, [
        _c("label", [
          _c("input", {
            attrs: { type: "search", placeholder: _vm.input.searchPlaceholder },
            on: {
              keyup: function ($event) {
                return _vm.searchTable($event)
              },
              blur: function ($event) {
                return _vm.searchTable($event)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("table", { ref: "table" }, [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.input.forms, function (col) {
              return col.type != "hidden"
                ? _c(
                    "td",
                    [
                      _c("div", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(col.name) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      col.helper
                        ? _c("HelperBox", { attrs: { text: col.helper } })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e()
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(
            _vm.getNestedValue(_vm.formValue, _vm.input.value),
            function (sectionValue, index) {
              return !sectionValue[_vm.input.forms[6].value]
                ? _c(
                    "tr",
                    {
                      class: sectionValue.isDeleted ? "deleted" : "",
                      attrs: {
                        "data-search":
                          sectionValue[_vm.input.forms[1].value].toLowerCase() +
                          " " +
                          sectionValue[_vm.input.forms[2].value].toLowerCase() +
                          " " +
                          sectionValue[_vm.input.forms[3].value].toLowerCase(),
                      },
                    },
                    _vm._l(_vm.input.forms, function (sectionInput) {
                      return sectionInput.type != "hidden"
                        ? _c(
                            "td",
                            [
                              sectionInput.type == "label"
                                ? [
                                    _c("div", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            sectionValue[sectionInput.value]
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                  ]
                                : sectionInput.type == "button"
                                ? [
                                    _c(
                                      "button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.onArrayItemDelete(
                                              $event,
                                              sectionValue
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("X")]
                                    ),
                                  ]
                                : sectionInput.type == "number"
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "input inline",
                                        attrs: { type: "number" },
                                      },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            attrs: {
                                              type: "text",
                                              pattern:
                                                "[0-9]+([\\.][0-9]{1,2})?",
                                              placeholder:
                                                sectionInput.placeholder,
                                            },
                                            domProps: {
                                              value: _vm.getNestedValue(
                                                sectionValue,
                                                sectionInput.value
                                              ),
                                            },
                                            on: {
                                              keyup: function ($event) {
                                                return _vm.onInputValueChange(
                                                  $event,
                                                  sectionInput.value,
                                                  sectionValue
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getInlineText(
                                                  sectionInput.inline
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c("InputField", {
                                      attrs: {
                                        input: sectionInput,
                                        formValue: sectionValue,
                                      },
                                    }),
                                  ],
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e()
            }
          ),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }